export interface Dimensions {
    width: number;
    height: number;
}

export default interface Placeholder {
    readonly file: File;
    readonly id?: string;
    readonly filename: string;
    readonly largeThumbUrl?: string;
    readonly smallThumbUrl?: string;
    readonly dimensions?: Dimensions;
    readonly smallThumbDimensions?: Dimensions;
    readonly largeThumbDimensions?: Dimensions;
    readonly dataHash?: string;
    readonly perceptualHash?: string;
    readonly overwriteId?: string;
}

export interface FinishedPlaceholder {
    readonly file: File;
    readonly id: string;
    readonly filename: string;
    readonly largeThumbUrl: string;
    readonly smallThumbUrl: string;
    readonly dimensions: Dimensions;
    readonly smallThumbDimensions: Dimensions;
    readonly largeThumbDimensions: Dimensions;
    readonly dataHash: string;
    readonly perceptualHash: string;
}

export const isPlaceholder = (p: unknown): p is Placeholder => !!((p as Placeholder).file);